const capitalizeWords = (str) => str.replace(/\b\w/g, (char) => char.toUpperCase());
export default capitalizeWords;
